import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

export const FrequencyResponse = ({ model, frequencyResponse }) => {
    const { t } = useTranslation();
    const freqResp = t(`${model}.freq_response`);
    const info =
        freqResp.localeCompare(`${model}.freq_response`) === 0 || freqResp === undefined
            ? frequencyResponse
            : freqResp;
    return (
        <Box className={layout.subSectionContainer} style={{ width: '100%' }}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.freq_response')}:{' '}
                </span>
                <span className={typography.modelDescription}>{info}</span>
            </Typography>
        </Box>
    );
};
